import { Request } from '@/classes/Request.ts'

export interface EnrollmentVerifyCodeResponse {
  success: boolean
  data?: { code_verified?: boolean }
  failure_reason?: string
}

/**
 * Verify the one-time code the invitee received by email. On success the backend
 * marks the invitation verified (fldChallengeVerifiedAt), unblocking
 * create-account / start-forms.
 * POST /api/enrollment/invitation/{token}/verify-code
 */
export const enrollmentVerifyCode = async (
  token: string,
  code: string
): Promise<EnrollmentVerifyCodeResponse> => {
  const response = await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/verify-code`,
    { code }
  )
  return response.data
}
